// extracted by mini-css-extract-plugin
export var searchHeader = "_9k-0";
export var searchHeaderDark = "_9k-1";